import API, { handleRequest } from "@/api/lib/api";

export const getAllTillDevices = () =>
  handleRequest(() => API.get("restaurant/devices/tills"));

export const getTillToTillShareOrders = (restaurantId, params = {}) =>
  handleRequest(() =>
    API.get(`restaurant/${restaurantId}/orders-not-completed`, { params }),
  );

export const shareOrderToTill = (orderId, payload) =>
  handleRequest(() => API.post(`restaurant/orders/${orderId}/share-till`, payload));

export const shareMultipleOrdersToTills = (restaurantId, payload) =>
  handleRequest(() =>
    API.post(`restaurant/${restaurantId}/orders/share-tills`, payload),
  );
